import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_LEAVES, SET_EMPLOYEE_LEAVE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_EMPLOYEE_LEAVE_ISLOADING,
  DELETE_EMPLOYEE_LEAVE,
  EDIT_EMPLOYEE_LEAVE,
  GET_EMPLOYEE_LEAVES,
  GET_EMPLOYEE_LEAVE,
  REGISTER_EMPLOYEE_LEAVE,
  APPROVE_EMPLOYEE_LEAVE,
  REJECT_EMPLOYEE_LEAVE,
  CANCEL_EMPLOYEE_LEAVE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeeLeave from '@/services/employee_leave';
import { Module } from 'vuex';
import { EditEmployeeLeave, RegisterEmployeeLeave, GetEmployeeLeave } from '@/dtos/employee_leave.dto';

const employeeLeave: Module<any, {}> = {
  state: {
    employeeLeave: {
      data: null,
      isLoading: false,
    },
    employeeLeaves: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeeLeave: (state: { employeeLeave: any }) => state.employeeLeave,
    employeeLeaves: (state: { employeeLeaves: any }) => state.employeeLeaves,
  },
  mutations: {
    [SET_EMPLOYEE_LEAVE]: (
      state: { employeeLeave: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeLeave.data = payload.data) : null,
        (state.employeeLeave.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_LEAVES]: (
      state: { employeeLeaves: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeLeaves.data = payload.data) : null,
        (state.employeeLeaves.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EMPLOYEE_LEAVE]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_LEAVE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeLeave.registerEmployeeLeave(
        payload as RegisterEmployeeLeave
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_LEAVE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_LEAVE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_LEAVE, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_LEAVES]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_LEAVES, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeLeave.getEmployeeLeaves(
        payload as GetEmployeeLeave
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_LEAVES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_LEAVES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_LEAVES, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_LEAVE]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_LEAVES, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeLeave.getEmployeeLeaves(
        payload as GetEmployeeLeave
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_LEAVES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_LEAVES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_LEAVES, { isLoading: false });
        return false;
      }
    },
    [EDIT_EMPLOYEE_LEAVE]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_LEAVE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeLeave.editEmployeeLeave(
        payload as EditEmployeeLeave
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_LEAVE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_LEAVE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_LEAVE, { isLoading: false });
        return false;
      }
    },
    [APPROVE_EMPLOYEE_LEAVE]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_LEAVE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeLeave.approveEmployeeLeave(
        payload as EditEmployeeLeave
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_LEAVE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_LEAVE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_LEAVE, { isLoading: false });
        return false;
      }
    },
    [REJECT_EMPLOYEE_LEAVE]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_LEAVE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeLeave.rejectEmployeeLeave(
        payload as EditEmployeeLeave
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_LEAVE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_LEAVE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_LEAVE, { isLoading: false });
        return false;
      }
    },
    [CANCEL_EMPLOYEE_LEAVE]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_LEAVE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeLeave.cancelEmployeeLeave(
        payload as EditEmployeeLeave
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_LEAVE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_LEAVE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_LEAVE, { isLoading: false });
        return false;
      }
    },
    [DELETE_EMPLOYEE_LEAVE]: async ({ commit }: any, payload: string) => {
      commit(SET_EMPLOYEE_LEAVE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeLeave.deleteEmployeeLeave(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_LEAVE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_LEAVE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_LEAVE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EMPLOYEE_LEAVE_ISLOADING]: ({ commit }) => {
      commit(SET_EMPLOYEE_LEAVE, { isLoading: false });
      commit(SET_EMPLOYEE_LEAVES, { isLoading: false });
    },
  },
};

export default employeeLeave;
